import { deleteAllAppointmentsV3 } from 'actions/scheduler/deleteAllAppointments.action';
import {
  aTypeCreateUpdateTimeoff,
  aTypeFetchEventsBySalon,
  aTypeFetchProceduresBySalon,
  aTypeUndoProcedure,
  aTypeUpdateProcedure,
} from 'actions/shared.types';
import logger from 'utils/logger.util';

const L = logger('determineIfDragDisablingFetch'); // eslint-disable-line no-unused-vars

const determineIfDragDisablingFetch = (options) => {
  const requestStatus = options?.requestStatus ?? {};

  if (requestStatus[aTypeFetchEventsBySalon.name]) return true;
  if (requestStatus[aTypeFetchProceduresBySalon.name]) return true;

  if (requestStatus[aTypeCreateUpdateTimeoff.name]) return true;

  if (requestStatus[aTypeUpdateProcedure.name]) return true;
  if (requestStatus[deleteAllAppointmentsV3.AT.name]) return true;

  // noinspection RedundantIfStatementJS
  if (requestStatus[aTypeUndoProcedure.name]) return true;

  return false;
};

export default determineIfDragDisablingFetch;
